import News from "./News";
import CreateNews from "./CreateNews";
import DeleteNews from "./DeleteNews";
import ViewMoreNews from "./ViewMoreNews";

export { News, CreateNews, DeleteNews, ViewMoreNews };
